module.exports = __webpack_public_path__ + "img/052-fatherhood.552601dd.svg";